import { TicketBuyerLimits } from "@ac-expo/api-types";
import { BuyableEntryTypeWithKey, EntryType, UseLocalCartReturns } from "@ac-expo/hooks";
import { SingleItemTicketing } from "./SingleItemTicketing";

const DEFAULT_TITLES: Record<EntryType, string> = {
  ticket: "Billets",
  badge: "Badges",
  activity: "Billets animation",
};

type TicketingListProps<T extends EntryType> = {
  type: T;
  buyableEntries: BuyableEntryTypeWithKey<T>[];
  localCart: UseLocalCartReturns;
  title?: string;
  buyer?: TicketBuyerLimits;
};

export function TicketingList<T extends EntryType>({
  type,
  buyableEntries,
  localCart,
  title = DEFAULT_TITLES[type],
  buyer,
}: TicketingListProps<T>) {
  if (buyableEntries.length === 0) {
    return null;
  }

  return (
    <>
      <h5 className="flex justify-start font-bold">{title}</h5>

      {buyableEntries.map((entry) => (
        <SingleItemTicketing
          key={entry.itemKey}
          entry={entry}
          localCart={localCart}
          buyer={buyer}
        />
      ))}
    </>
  );
}
